import React, { useMemo } from 'react';
import './index.scss';
import { coverSVG } from '../../common/nexusArt';
import { INSTITUTIONS } from './Institutions';
import Twinkle from '../Twinkle';
import { useVideoModal } from '../VideoModal';

const demoVideoId = 'YDaHCgtROck';
const PAPER_URL = 'https://arxiv.org/abs/2604.08491';

/* Hero: a branching walk through findings on the left, the title and institutions on the right */
const TeaserPage: React.FC = () => {
  const art = useMemo(() => coverSVG.hero(), []);
  const { open } = useVideoModal();
  const openDemo = (e: React.MouseEvent) => {
    e.preventDefault();
    open({ source: { kind: 'youtube', id: demoVideoId }, title: 'Product walkthrough', kicker: 'Nexus · 2:50' });
  };

  return (
    <section className="hero" id="top">
      <div className="art">
        <svg id="heroart" viewBox="0 0 800 720" preserveAspectRatio="xMidYMid slice" role="img" aria-label="A branching walk through findings" dangerouslySetInnerHTML={{ __html: art }} />
        <Twinkle count={30} seed={1} />
      </div>
      <div className="copy">
        <h1>LLM-Native Figures</h1>
        <p className="lede">Transforming Figures into Engines of Discovery.</p>
        <div className="links"><a className="pri" href="#walkthrough" onClick={openDemo}><svg viewBox="0 0 9 10" aria-hidden="true"><path d="M0 0l9 5-9 5z" /></svg>Watch the demo</a><a href={PAPER_URL} target="_blank" rel="noopener noreferrer">Read the paper</a></div>
        <div className="logorow" id="herologos" aria-label="Institutions">
          {INSTITUTIONS.map((l) => <span key={l.alt}><img src={l.src} alt={l.alt} style={{ maxHeight: l.heroHeight }} /></span>)}
        </div>
      </div>
    </section>
  );
};

export default TeaserPage;
